/* eslint-disable no-unused-vars */
import React, { Component } from 'react';

import Main from './Containers/Main';

class App extends Component {
  render() {
    return (
      <>
        <Main />
      </>
    );
  }
}

export default App;
